import React from 'react';
import PropTypes from 'prop-types';

/* React Router */
import { useNavigate } from 'react-router-dom';

/* Material UI */
import { AppBar, Toolbar, Typography, IconButton, Button, Icon, Hidden } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { PhoneEnabled } from '@mui/icons-material';

// Project
// import Logo from '/assets/images/TcitLogo_123x50.png';
import { useDispatch, useSelector } from 'react-redux';
import { resetStepsState } from 'content/features/schedulerSteps/schedulerSteps.actions';
import {
  controlsChanged,
  resetWelcomeScreenControls,
} from 'content/features/welcomeScreens/welcomeScreens.actions';
import { resetAnnulmentState } from 'content/features/annulmentSteps/annulmentSteps.actions';
import navbarStyles from './navbar.styles';
import colors from 'utils/colors';
import { setView } from 'content/app.actions';

const SalfaLogo = `${window.location.origin}/images/salfa-logo.png`;

function NavBar(props) {
  const { setOpenDrawer } = props;

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const preSelectedService = useSelector(
    (state) => state.welcomeScreen.controls.preSelectedService,
  );

  const redirectHome = () => {
    dispatch(resetStepsState());
    dispatch(resetWelcomeScreenControls());
    dispatch(resetAnnulmentState());
    navigate('/');
  };

  const handleSelectService = (service) => {
    dispatch(resetWelcomeScreenControls());
    dispatch(resetStepsState());
    dispatch(resetAnnulmentState());
    navigate('/');
    dispatch(controlsChanged({ name: 'preSelectedService', value: service }));
    dispatch(setView({ value: service }));
  };

  return (
    <AppBar position="static" color="inherit" style={{ background: '#002855' }}>
      <Toolbar>
        <IconButton
          data-testid="toolbar-menu-button"
          onClick={() => setOpenDrawer(true)}
          edge="start"
          sx={navbarStyles.menuButton}
          color="inherit"
          aria-label="menu">
          <MenuIcon />
        </IconButton>
        <IconButton onClick={redirectHome}>
          <img style={{ height: '30px' }} src={SalfaLogo} alt="" />
        </IconButton>
        <Typography variant="h6" sx={navbarStyles.title} color="primary" />
        <Hidden mdDown>
          <Button
            size="large"
            sx={navbarStyles.button}
            onClick={() => handleSelectService('scheduling')}>
            <Typography
              fontWeight="bold"
              color="white"
              sx={{ opacity: preSelectedService === 'scheduling' ? 0.7 : 1 }}>
              Agendamiento
            </Typography>
          </Button>
          <Button
            size="large"
            sx={navbarStyles.button}
            onClick={() => handleSelectService('reschedule')}>
            <Typography
              fontWeight="bold"
              color="white"
              sx={{ opacity: preSelectedService === 'reschedule' ? 0.7 : 1 }}>
              Reagendamiento
            </Typography>
          </Button>
          <Button
            size="large"
            sx={navbarStyles.button}
            onClick={() => handleSelectService('annulment')}>
            <Typography
              fontWeight="bold"
              color="white"
              sx={{ opacity: preSelectedService === 'annulment' ? 0.7 : 1 }}>
              Anular Hora
            </Typography>
          </Button>
          <Typography display="flex" alignItems="center" ml={2} fontWeight="bold" color="white">
            <PhoneEnabled />
            600 360 6200
          </Typography>
        </Hidden>
      </Toolbar>
    </AppBar>
  );
}

NavBar.propTypes = {
  user: PropTypes.shape({}),
};

NavBar.defaultProps = {
  user: null,
};

export default NavBar;
